import React, { useState } from 'react';

export const SCHEDULE_TYPE_OPTIONS = [
  'Account Summary',
  'Commissary Ordering',
  'Games',
  'Inbound Audio Calls',
  'Inmate Requests',
  'Job Search',
  'Kiosk Audio Calls',
  'Law Library',
  'Music',
  'Reference Material',
  'Texting',
  'Video Calls',
  'Visitation',
  'Wireless Audio Calls',
  'Wireless Video Calls',
  'Wireless Video Visitations',
] as const;

type AddProps = {
  onAdd: (payload: { type: string }) => void;
};

const Add: React.FC<AddProps> = ({ onAdd }) => {
  const [scheduleType, setScheduleType] = useState('');

  return (
    <form
      className="row d-print-none"
      onSubmit={(e) => {
        e.preventDefault();
        if (scheduleType !== '') {
          onAdd({ type: scheduleType });
        }
      }}>
      <div className="col-md-2 form-group">
        <select className="form-control" value={scheduleType} onChange={(e) => setScheduleType(e.target.value)}>
          <option value="">Select type</option>
          {SCHEDULE_TYPE_OPTIONS.map((opt) => (
            <option key={opt} value={opt}>
              {opt}
            </option>
          ))}
        </select>
      </div>
      <div className="form-group mt-1">
        <button className="btn btn-primary" type="submit" disabled={scheduleType === ''}>
          Add Schedule
        </button>
      </div>
    </form>
  );
};

export default Add;
